import React, { useRef } from 'react'
import { useParams } from 'react-router-dom';
import axios from "axios";
import config from "../../config"
import Header from './Header';
import Footer from './Footer';



const Cancel_logs = () => {
    const { task_id } = useParams();
    const [logs, setLogs] = React.useState([]);
    const [total, setTotal] = React.useState(0);
    const [completed, setCompleted] = React.useState(0);
    const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
    const[isLoading , setisLoading] = React.useState(true)
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
        const homeSection = document.querySelector('.home-section');
        if (homeSection) {
            homeSection.classList.toggle('sidebar-closed');
        }
    };
    const fetchLogs = () => {
      axios.post(`${config.apiUrl}/shipment/cancel_bulk_logs`,{task_id:task_id},{ headers: config.headers })
        .then(res => {
          setLogs(res.data.logs);
          setTotal(res.data.total);
          setCompleted(res.data.completed);
        });
    };
  
    React.useEffect(() => {
      fetchLogs();
      const interval = setInterval(fetchLogs, 1000); // every 1 sec
      return () => clearInterval(interval);
    }, []);
  
    return (
   
        <div>
        <Header/>
      <div class="page-wrapper pinned">
       <div class="main-container">
        <div className='app-container'>
       <div class="app-body">
       <div class="container-fluid"> 
       <section class="mb-3 pt-4">
<div class="">
  <div class="row mb-3">
    <div class="col-12 col-md-3">
      <h3><a href="/customer/shipments"><i class="fa fa-chevron-left" aria-hidden="true"></i></a>  Bulk Cancel Log</h3>
    </div>
    <div class="col-12 col-md text-end">
      <h3>{completed}<small class="text-muted">/{total}</small></h3>
    </div>
  </div> 

  
     
</div>
</section>


<section class="mb-3">
<div class="">
  <div class="table-responsive">
      <table class="table table_box">
          <thead  class="">
              <tr class="brd">
              <th>Log ID</th>
              <th>AWB No.</th>
              <th>Status</th>
              <th>Message</th>
          </tr>
          </thead>
          <tbody>
              {logs.map((log, i)=>(

             
              <tr class="brd">
                  <td>
                      <h5><a >{task_id}</a></h5>
                  </td>
                  <td>
                   <small>{log.awb_number}</small>
                  </td>
                  <td>
                     <span>{log.status}</span>
                  </td>
                  <td>
                  <small>{log.message}</small> 
                  </td>
                 
              </tr>
               ))}
          </tbody>
      </table>
  </div>     
</div>
</section>
       </div></div>
       <Footer/></div></div></div></div>
  )
}

export default Cancel_logs
